<template>
  <div id="gastosViaje">
    <v-card class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-toolbar-title>Anticipos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="newRequest()">
            <v-icon>note_add</v-icon>
          </v-btn>
          <span>Nuevo Anticipo</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="refresh">Actualizar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details
          maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="anticipos" :loading="loading" :search="search"
        rows-per-page-text="Registros por página" :pagination.sync="pagination" class="elevation-1">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center" @click="showDetailReq(props.item.id)">{{ props.item.id_seg }}</td>
          <td class="text-xs-center" @click="showDetailReq(props.item.id)">{{ props.item.estado }}</td>
          <td class="text-xs-center" @click="showDetailReq(props.item.id)">{{ props.item.estado_comprobacion }}</td>
          <td class="text-xs-center" @click="showDetailReq(props.item.id)">{{ props.item.fecha_salida }}</td>
          <td class="text-xs-center" @click="showDetailReq(props.item.id)">{{ props.item.fecha_regreso }}</td>
          <td class="text-xs-center" @click="showDetailReq(props.item.id)">$ {{
            props.item.importe_anticipo.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
          <td class="text-xs-center" @click="showDetailReq(props.item.id)">$ {{
            props.item.importe_comprobado.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
          <td class="text-xs-center" @click="showDetailReq(props.item.id)">$ {{
            props.item.importe_restante.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
          <!--<td class="text-xs-center" @click="showDetailReq(props.item.id)">{{ props.item.fecha_registro }}</td>-->
          <td class="text-xs-center" @click="showDetailReq(props.item.id)">{{ props.item.fecha_actualizacion }}</td>
        </template>
        <template slot="pageText" slot-scope="props">
          Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <div class="text-xs-center"></div>
        </template>
        <template slot="no-results">
          <div class="text-xs-center">
            No se obtuvieron resultados
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogNewReq" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Solicitud de autorización y anticipo de viaje</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat :loading="loading" @click="questionReq = true">Guardar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">DATOS DEL SOLICITANTE</h3><br />
                  <v-text-field v-model="solicitud.beneficiario" :error-messages="beneficiarioErrors"
                    label="Beneficiario" @input="$v.solicitud.beneficiario.$touch()"
                    @blur="$v.solicitud.beneficiario.$touch()" box readonly></v-text-field>
                  <v-text-field v-model="solicitud.puesto" :error-messages="puestoErrors" label="Puesto"
                    @input="$v.solicitud.puesto.$touch()" @blur="$v.solicitud.puesto.$touch()" box
                    readonly></v-text-field>
                  <v-text-field v-model="solicitud.empresa" :error-messages="empresaErrors" label="Empresa"
                    @input="$v.solicitud.empresa.$touch()" @blur="$v.solicitud.empresa.$touch()" box
                    readonly></v-text-field>
                  <v-text-field v-model="solicitud.plaza" :error-messages="plazaErrors" label="UEN / Plaza"
                    @input="$v.solicitud.plaza.$touch()" @blur="$v.solicitud.plaza.$touch()" box
                    readonly></v-text-field>
                  <v-text-field v-model="solicitud.departamento" :error-messages="departamentoErrors"
                    label="Departamento" @input="$v.solicitud.departamento.$touch()"
                    @blur="$v.solicitud.departamento.$touch()" box readonly></v-text-field>
                  <v-select v-model="solicitud.centro" :error-messages="centroErrors" label="Centro de costos"
                    :items="catalogos.centros" @input="$v.solicitud.centro.$touch()"
                    @blur="$v.solicitud.centro.$touch()" item-text="descripcion" item-value="id"></v-select>
                  <br />
                  <h3 class="grey--text">DATOS GENERALES DEL ANTICIPO</h3><br />
                  <v-radio-group v-model="solicitud.tipo_solicitud" :error-messages="tipoSolicitudErrors"
                    :mandatory="false" @input="$v.solicitud.tipo_solicitud.$touch()"
                    @blur="$v.solicitud.tipo_solicitud.$touch()">
                    <div slot="label"><strong>Tipo de solicitud</strong></div>
                    <v-radio label="Cheque" color="primary" value="cheque"></v-radio>
                    <v-radio label="Transferencia" color="primary" value="transferencia"></v-radio>
                  </v-radio-group><br />
                  <template v-if="solicitud.tipo_solicitud === 'transferencia'">
                    <v-text-field v-model="solicitud.banco" :error-messages="bancoErrors" label="Banco"
                      @input="$v.solicitud.banco.$touch()" @blur="$v.solicitud.banco.$touch()" box
                      readonly></v-text-field>
                    <v-text-field v-model="solicitud.cuenta" :error-messages="cuentaErrors" label="No. Cuenta"
                      @input="$v.solicitud.cuenta.$touch()" @blur="$v.solicitud.cuenta.$touch()" box
                      readonly></v-text-field>
                    <v-text-field v-model="solicitud.tarjeta" :error-messages="tarjetaErrors" label="No. Tarjeta"
                      @input="$v.solicitud.tarjeta.$touch()" @blur="$v.solicitud.tarjeta.$touch()" box
                      readonly></v-text-field>
                    <v-text-field v-model="solicitud.clabe" :error-messages="clabeErrors"
                      label="Referencia interbancaria" @input="$v.solicitud.clabe.$touch()"
                      @blur="$v.solicitud.clabe.$touch()" box readonly></v-text-field><br />
                  </template>
                  <!--<h3 class="grey--text">RESERVACIÓN</h3><br/>
                  <v-text-field v-model="solicitud.aerolinea" :error-messages="aerolineaErrors" label="Aerolinea"
                  @input="$v.solicitud.aerolinea.$touch()" @blur="$v.solicitud.aerolinea.$touch()"></v-text-field>
                  <v-text-field v-model="solicitud.hotel" :error-messages="hotelErrors" label="Hotel"
                  @input="$v.solicitud.hotel.$touch()" @blur="$v.solicitud.hotel.$touch()"></v-text-field>
                  <v-text-field v-model="solicitud.costo_boleto" :error-messages="costoBoletoErrors" label="Costo de boleto expedido"
                  @input="$v.solicitud.costo_boleto.$touch()" @blur="$v.solicitud.costo_boleto.$touch()"
                  prefix="$" suffix="MXN"></v-text-field>
                  <v-text-field v-model="solicitud.no_noches" :error-messages="noNochesErrors" label="No. Noches"
                  @input="$v.solicitud.no_noches.$touch()" @blur="$v.solicitud.no_noches.$touch()"></v-text-field>
                  <v-text-field v-model="solicitud.tarifa" :error-messages="tarifaErrors" label="Tarifa"
                  @input="$v.solicitud.tarifa.$touch()" @blur="$v.solicitud.tarifa.$touch()" prefix="$" suffix="MXN"></v-text-field>-->
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">DATOS DEL VIAJE</h3><br />
                  <v-text-field v-model="solicitud.destino" :error-messages="destinoErrors" label="Destino"
                    @input="$v.solicitud.destino.$touch()" @blur="$v.solicitud.destino.$touch()"></v-text-field>
                  <v-select v-model="solicitud.motivo_viaje" :error-messages="motivoViajeErrors"
                    :items="catalogos.motivos_viaje" @input="$v.solicitud.motivo_viaje.$touch()"
                    @blur="$v.solicitud.motivo_viaje.$touch()" item-text="descripcion" item-value="descripcion"
                    label="Motivo de viaje"></v-select>
                  <v-menu ref="menuDateExit" :close-on-content-click="false" v-model="menuDateExit" :nudge-right="40"
                    :return-value.sync="menuDateExit" lazy transition="scale-transition" offset-y full-width
                    min-width="290px">
                    <v-text-field slot="activator" v-model="solicitud.fecha_salida" :error-messages="fechaSalidaErrors"
                      label="Fecha de salida" @input="$v.solicitud.fecha_salida.$touch()"
                      @blur="$v.solicitud.fecha_salida.$touch()" readonly></v-text-field>
                    <v-date-picker v-model="solicitud.fecha_salida" color="error" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menuDateExit = false">Cancelar</v-btn>
                      <v-btn flat color="primary" @click="$refs.menuDateExit.save(solicitud.fecha_salida)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                  <v-menu ref="menuDateReturn" :close-on-content-click="false" v-model="menuDateReturn"
                    :nudge-right="40" :return-value.sync="menuDateReturn" lazy transition="scale-transition" offset-y
                    full-width min-width="290px">
                    <v-text-field slot="activator" v-model="solicitud.fecha_regreso"
                      :error-messages="fechaRegresoErrors" label="Fecha de regreso"
                      @input="$v.solicitud.fecha_regreso.$touch()" @blur="$v.solicitud.fecha_regreso.$touch()"
                      readonly></v-text-field>
                    <v-date-picker v-model="solicitud.fecha_regreso" color="error" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menuDateReturn = false">Cancelar</v-btn>
                      <v-btn flat color="primary" @click="$refs.menuDateReturn.save(solicitud.fecha_regreso)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                  <v-text-field v-model="solicitud.dias_viaje" :error-messages="diasViajeErrors"
                    @input="$v.solicitud.dias_viaje.$touch()" @blur="$v.solicitud.dias_viaje.$touch()"
                    label="Días de viaje" box readonly :value="diasViaje"></v-text-field>
                  <!--<br/>
                  <p>
                    Ruta de traslado
                  </p>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md4>
                      <v-checkbox v-model="solicitud.ruta_traslado" :error-messages="rutaTrasladoErrors" label="Avión" color="primary"
                      @input="$v.solicitud.ruta_traslado.$touch()" @blur="$v.solicitud.ruta_traslado.$touch()" value="avion"></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-checkbox v-model="solicitud.ruta_traslado" label="Autobus" color="primary"
                      @input="$v.solicitud.ruta_traslado.$touch()" @blur="$v.solicitud.ruta_traslado.$touch()" value="autobus"></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-checkbox v-model="solicitud.ruta_traslado" label="Auto" color="primary"
                      @input="$v.solicitud.ruta_traslado.$touch()" @blur="$v.solicitud.ruta_traslado.$touch()" value="auto"></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <br/>-->
                  <!--<h3 class="grey--text">DESGLOSE DEL ANTICIPO REQUERIDO</h3><br/>
                  <v-text-field v-for="(concepto, idx) in catalogos.conceptos" :key="idx" v-model="solicitud.conceptos[idx]['importe']"
                  :error-messages="importeErrors(idx)" :label="concepto.descripcion.split('-')[1].trim()" @input="$v.solicitud.conceptos.$each[idx].importe.$touch()"
                  @blur="$v.solicitud.conceptos.$each[idx].importe.$touch()" prefix="$" suffix="MXN"></v-text-field>-->
                  <v-text-field v-model="solicitud.importe_total" :error-messages="importeTotalErrors"
                    @input="$v.solicitud.importe_total.$touch()" @blur="$v.solicitud.importe_total.$touch()"
                    label="Importe total" prefix="$" suffix="MXN"></v-text-field>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNewChk" :persistent="true" width="500">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Nuevo Comprobante</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>No. {{ detalle.resumen.no_comprobantes + 1 }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-radio-group v-model="detalle.nuevo_comprobante.tipo_gasto" :error-messages="tipoGastoErrors"
              :mandatory="false" @input="$v.detalle.nuevo_comprobante.tipo_gasto.$touch()"
              @blur="$v.detalle.nuevo_comprobante.tipo_gasto.$touch()">
              <div slot="label"><strong>Tipo de gasto</strong></div>
              <v-radio label="Deducible" color="primary" value="deducible"></v-radio>
              <v-radio label="No deducible" color="primary" value="no_deducible"></v-radio>
            </v-radio-group>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-btn block round :color="color.pdf" v-show="gastoDeducible" @click="$refs.pdf.click()">
                  PDF
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
                <input v-show="false" ref="pdf" type="file" @change="readFile('pdf')">
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-btn block round :color="color.xml" v-show="gastoDeducible" @click="$refs.xml.click()">
                  XML
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
                <input v-show="false" ref="xml" type="file" @change="readFile('xml')">
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-btn block round :color="color.foto" v-show="!gastoDeducible" @click="$refs.foto.click()">
                  Foto
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
                <input v-show="false" ref="foto" type="file" @change="readFile('foto')"><br />
              </v-flex>
            </v-layout>
            <!--<v-select v-model="detalle.nuevo_comprobante.centro" label="Centro de costos" :items="detalle.centros"
            item-text="descripcion" item-value="id"></v-select>-->
            <v-select v-model="detalle.nuevo_comprobante.concepto" :error-messages="conceptoErrors" label="Concepto"
              :items="detalle.conceptos" @input="$v.detalle.nuevo_comprobante.concepto.$touch()"
              @blur="$v.detalle.nuevo_comprobante.concepto.$touch()" item-text="descripcion" item-value="id"
              readonly></v-select>
            <v-select v-model="detalle.nuevo_comprobante.detalle_no" v-show="!gastoDeducible"
              :error-messages="detalleNoErrors" label="Detalle" :items="detalle.detalles_no"
              @input="$v.detalle.nuevo_comprobante.detalle_no.$touch()"
              @blur="$v.detalle.nuevo_comprobante.detalle_no.$touch()" item-text="descripcion"
              item-value="id"></v-select><br />
            <v-text-field v-model="detalle.nuevo_comprobante.rfc" v-show="gastoDeducible" :error-messages="rfcErrors"
              label="RFC" @input="$v.detalle.nuevo_comprobante.rfc.$touch()"
              @blur="$v.detalle.nuevo_comprobante.rfc.$touch()" box readonly></v-text-field>
            <v-text-field v-model="detalle.nuevo_comprobante.beneficiario" v-show="gastoDeducible"
              :error-messages="beneficiarioErrors" label="Beneficiario"
              @input="$v.detalle.nuevo_comprobante.beneficiario.$touch()"
              @blur="$v.detalle.nuevo_comprobante.beneficiario.$touch()" box readonly></v-text-field>
            <v-text-field v-model="detalle.nuevo_comprobante.folio" v-show="gastoDeducible"
              :error-messages="folioErrors" label="Folio" @input="$v.detalle.nuevo_comprobante.folio.$touch()"
              @blur="$v.detalle.nuevo_comprobante.folio.$touch()" box :readonly="!editNoFactura"></v-text-field>
            <v-text-field v-model="detalle.nuevo_comprobante.uuid" v-show="gastoDeducible" :error-messages="uuidErrors"
              label="UUID" @input="$v.detalle.nuevo_comprobante.uuid.$touch()"
              @blur="$v.detalle.nuevo_comprobante.uuid.$touch()" box readonly></v-text-field>
            <v-text-field v-model="detalle.nuevo_comprobante.subtotal" :error-messages="subtotalErrors" label="Subtotal"
              @input="$v.detalle.nuevo_comprobante.subtotal.$touch()"
              @blur="$v.detalle.nuevo_comprobante.subtotal.$touch()" prefix="$" suffix="MXN"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field :disabled="esNoDeducible" v-model="detalle.nuevo_comprobante.descuento"
              :error-messages="descuentoErrors" label="Descuento"
              @input="$v.detalle.nuevo_comprobante.descuento.$touch()"
              @blur="$v.detalle.nuevo_comprobante.descuento.$touch()" prefix="$" suffix="MXN"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field :disabled="esNoDeducible" v-model="detalle.nuevo_comprobante.iva" :error-messages="ivaErrors"
              label="IVA" @input="$v.detalle.nuevo_comprobante.iva.$touch()"
              @blur="$v.detalle.nuevo_comprobante.iva.$touch()" prefix="$" suffix="MXN" :value="iva"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-model="detalle.nuevo_comprobante.total" :error-messages="totalErrors" label="Total"
              @input="$v.detalle.nuevo_comprobante.total.$touch()" @blur="$v.detalle.nuevo_comprobante.total.$touch()"
              prefix="$" suffix="MXN" :value="total" readonly></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat v-show="!loading" color="blue-grey" @click.native="closeNewChk()">Cancelar</v-btn>
          <v-btn dark color="blue-grey" :loading="loading" @click.native="saveNewChk()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetChk" :persistent="true" width="500">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Detalle de Comprobante</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>No. {{ detalle.detalle_comprobante.index + 1 }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-radio-group v-model="detalle.detalle_comprobante.tipo_gasto" :mandatory="false" disabled>
              <div slot="label"><strong>Tipo de gasto</strong></div>
              <v-radio label="Deducible" color="primary" value="deducible"></v-radio>
              <v-radio label="No deducible" color="primary" value="no_deducible"></v-radio>
            </v-radio-group>
            <!--<v-select v-model="detalle.detalle_comprobante.centro" label="Centro de costos" :items="detalle.centros"
            item-text="descripcion" item-value="id" box disabled></v-select>-->
            <v-select v-model="detalle.detalle_comprobante.concepto" label="Concepto" :items="detalle.conceptos"
              item-text="descripcion" item-value="id" box disabled></v-select>
            <v-select v-model="detalle.detalle_comprobante.detalle_no" v-show="!detalleGastoDeducible" label="Detalle"
              :items="detalle.detalles_no" item-text="descripcion" item-value="id" box disabled></v-select>
            <v-layout wrap>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument('pdf')">
                  PDF
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument('xml')">
                  XML
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument('foto')">
                  Foto
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout><br />
            <v-text-field v-model="detalle.detalle_comprobante.rfc" v-show="detalleGastoDeducible" label="RFC" box
              disabled></v-text-field>
            <v-text-field v-model="detalle.detalle_comprobante.beneficiario" v-show="detalleGastoDeducible"
              label="Beneficiario" box disabled></v-text-field>
            <v-text-field v-model="detalle.detalle_comprobante.folio" v-show="detalleGastoDeducible" label="Folio" box
              disabled></v-text-field>
            <v-text-field v-model="detalle.detalle_comprobante.uuid" v-show="detalleGastoDeducible" label="UUID" box
              disabled></v-text-field>
            <v-text-field v-model="detalle.detalle_comprobante.subtotal" label="Subtotal" prefix="$" suffix="MXN"
              disabled></v-text-field>
            <v-text-field v-model="detalle.detalle_comprobante.descuento" label="Descuento" prefix="$" suffix="MXN"
              disabled></v-text-field>
            <v-text-field v-model="detalle.detalle_comprobante.iva" label="IVA" prefix="$" suffix="MXN"
              disabled></v-text-field>
            <v-text-field v-model="detalle.detalle_comprobante.total" label="Total" prefix="$" suffix="MXN"
              disabled></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="dialogDetChk" flat color="error" @click.native="questionDelChk = true">Eliminar</v-btn>
          <v-btn flat color="blue-grey" @click.native="closeDetailChk()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetReq" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Detalle de autorización y anticipo de viaje</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-tooltip left>
              <v-btn slot="activator" :loading="loading" icon @click="print()">
                <v-icon>local_printshop</v-icon>
              </v-btn>
              <span>Imprimir</span>
            </v-tooltip>
            <v-btn dark flat :loading="loading" @click="questionChk = true">Comprobar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">DATOS DEL SOLICITANTE</h3><br />
                  <v-text-field v-model="detalle.beneficiario" label="Beneficiario" box disabled></v-text-field>
                  <v-text-field v-model="detalle.puesto" label="Puesto" box disabled></v-text-field>
                  <v-text-field v-model="detalle.empresa" label="Empresa" box disabled></v-text-field>
                  <v-text-field v-model="detalle.plaza" label="UEN / Plaza" box disabled></v-text-field>
                  <v-text-field v-model="detalle.departamento" label="Departamento" box disabled></v-text-field>
                  <v-text-field v-model="detalle.centro" label="Centro de costos" disabled></v-text-field>
                  <br />
                  <h3 class="grey--text">DATOS GENERALES DEL ANTICIPO</h3><br />
                  <v-radio-group v-model="detalle.tipo_solicitud" :mandatory="false" disabled>
                    <div slot="label"><strong>Tipo de solicitud</strong></div>
                    <v-radio label="Cheque" color="primary" value="cheque"></v-radio>
                    <v-radio label="Transferencia" color="primary" value="transferencia"></v-radio>
                  </v-radio-group>
                  <template v-if="detalle.tipo_solicitud === 'transferencia'">
                    <v-text-field v-model="detalle.banco" label="Banco" box disabled></v-text-field>
                    <v-text-field v-model="detalle.cuenta" label="No. Cuenta" box disabled></v-text-field>
                    <v-text-field v-model="detalle.tarjeta" label="No. Tarjeta" box disabled></v-text-field>
                    <v-text-field v-model="detalle.clabe" label="Referencia interbancaria" box
                      disabled></v-text-field><br />
                  </template>
                  <!--<h3 class="grey--text">RESERVACIÓN</h3><br/>
                  <v-text-field v-model="detalle.aerolinea" label="Aerolinea" disabled></v-text-field>
                  <v-text-field v-model="detalle.hotel" label="Hotel" disabled></v-text-field>
                  <v-text-field v-model="detalle.costo_boleto" label="Costo de boleto expedido" prefix="$" suffix="MXN" disabled></v-text-field>
                  <v-text-field v-model="detalle.no_noches" label="No. Noches" disabled></v-text-field>
                  <v-text-field v-model="detalle.tarifa" label="Tarifa" prefix="$" suffix="MXN" disabled></v-text-field>-->
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">DATOS DEL VIAJE</h3><br />
                  <v-text-field v-model="detalle.destino" label="Destino" disabled></v-text-field>
                  <v-text-field v-model="detalle.motivo_viaje" label="Motivo de viaje" disabled></v-text-field>
                  <v-text-field v-model="detalle.fecha_salida" label="Fecha de salida" disabled></v-text-field>
                  <v-text-field v-model="detalle.fecha_regreso" label="Fecha de regreso" disabled></v-text-field>
                  <v-text-field v-model="detalle.dias_viaje" label="Días de viaje" box disabled></v-text-field>
                  <br />
                  <!--<p>
                    Ruta de traslado
                  </p>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md4>
                      <v-checkbox v-model="detalle.ruta_traslado" label="Avión" color="primary" value="avion" disabled></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-checkbox v-model="detalle.ruta_traslado" label="Autobus" color="primary" value="autobus" disabled></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-checkbox v-model="detalle.ruta_traslado" label="Auto" color="primary" value="auto" disabled></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <br/>-->
                  <!--<h3 class="grey--text">DESGLOSE DEL ANTICIPO REQUERIDO</h3><br/>
                  <v-text-field v-for="(concepto, idx) in detalle.conceptos" :key="idx" v-model="detalle.conceptos[idx]['importe']"
                  :label="concepto.descripcion" prefix="$" suffix="MXN" disabled></v-text-field>-->
                  <v-text-field v-model="detalle.importe_total" label="Importe total" box prefix="$" suffix="MXN"
                    disabled></v-text-field>
                  <br />
                  <h3 class="grey--text">COMPROBANTES DE VIAJE</h3><br />
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <v-btn small block color="blue-grey" class="white--text" :loading="loading"
                        @click="dialogNewChk = true">
                        Agregar
                        <v-icon small right dark>add_circle</v-icon>
                      </v-btn><br />
                      <v-text-field v-model="detalle.resumen.no_comprobantes" label="No. Comprobantes" box
                        readonly></v-text-field>
                      <v-text-field v-model="detalle.resumen.iva" label="IVA" box prefix="$" suffix="MXN"
                        readonly></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <div class="text-xs-center">
                        <v-menu transition="slide-y-transition" top left offset-y full-width>
                          <v-btn slot="activator" :disabled="detalle.comprobantes.length == 0" :loading="loading" small
                            block color="blue-grey" class="white--text">
                            Mostrar
                            <v-icon small right dark>remove_red_eye</v-icon>
                          </v-btn>
                          <v-list v-if="detalle.comprobantes.length > 0">
                            <v-list-tile v-for="(chk, idx) in detalle.comprobantes" :key="idx"
                              @click="showDetailChk(idx)">
                              <v-list-tile-title
                                v-text="detalle.conceptos.filter(concepto => { return concepto.id == chk.concepto })[0].descripcion"></v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </div><br />
                      <v-text-field v-model="detalle.resumen.subtotal" label="Subtotal" box prefix="$" suffix="MXN"
                        readonly></v-text-field>
                      <v-text-field v-model="detalle.resumen.neto" label="Neto" box prefix="$" suffix="MXN"
                        readonly></v-text-field>
                    </v-flex>
                  </v-layout>
                  <template
                    v-if="(parseFloat(detalle.importe_total.toString().replace(/\,/g, '')) - parseFloat(detalle.resumen.neto.toString().replace(/\,/g, ''))) < 0">
                    <v-btn v-if="detalle.estado != 'Reembolsado'" block :loading="loading" color="blue-grey"
                      class="white--text" @click="reimburse()">
                      Solicitar reembolso
                      <v-icon right dark>monetization_on</v-icon>
                    </v-btn>
                    <v-btn v-else block color="blue-grey" class="white--text" disabled>
                      Solicitud de reembolso enviada
                      <v-icon right dark>monetization_on</v-icon>
                    </v-btn>
                  </template>
                  <br />
                  <h3 class="grey--text">RESUMEN</h3><br />
                  <v-data-table v-if="tableResumen.length" :headers="headersResumen" :items="tableResumen"
                    class="elevation-1" hide-actions no-data-text="">
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-right">{{ props.item.tipo_gasto }}</td>
                      <td class="text-xs-right">{{ props.item.concepto }}</td>
                      <td class="text-xs-right">{{ props.item.fecha_timbrado }}</td>
                      <!--<td class="text-xs-right">{{ props.item.proveedor }}</td>-->
                      <td class="text-xs-right">{{ props.item.subtotal }}</td>
                      <td class="text-xs-right">{{ props.item.iva }}</td>
                      <td class="text-xs-right">{{ props.item.total }}</td>
                    </template>
                  </v-data-table>
                  <br />
                  <h3 class="grey--text">FIRMAS (ANTICIPO)</h3><br />
                  <v-list three-line dark>
                    <template v-for="(item, i) in detalle.firmas_anticipo">
                      <v-list-tile class="pb-2 pt-2">
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                          <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                          <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                            v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider v-show="(i + 1) < detalle.firmas_anticipo.length"></v-divider>
                    </template>
                  </v-list><br />
                  <h3 class="grey--text">FIRMAS (COMPROBACIÓN)</h3><br />
                  <v-list v-if="detalle.firmas_comprobante.length" three-line dark>
                    <template v-for="(item, i) in detalle.firmas_comprobante">
                      <v-list-tile class="pb-2 pt-2">
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                          <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                          <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                            v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider v-show="(i + 1) < detalle.firmas_comprobante.length"></v-divider>
                    </template>
                  </v-list>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionReq" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea confirmar la solicitud?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionReq = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="save()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionChk" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea comprobar las facturas?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionChk = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="check()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionDelChk" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea eliminar el comprobante?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionDelChk = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="removeElement()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import services from "@/config/services";
import axios from "axios";
import download from "downloadjs";
import moment from "moment";
import { validationMixin } from "vuelidate";
import {
  decimal,
  integer,
  maxLength,
  maxValue,
  minValue,
  requiredIf
} from "vuelidate/lib/validators";

export default {
  name: "gastosViaje",
  mixins: [validationMixin],
  validations: {
    solicitud: {
      beneficiario: {
        required: requiredIf(function () {
          return !this.isNewChk;
        })
      },
      puesto: {
        required: requiredIf(function () {
          return !this.isNewChk;
        })
      },
      empresa: {
        required: requiredIf(function () {
          return !this.isNewChk;
        })
      },
      plaza: {
        required: requiredIf(function () {
          return !this.isNewChk;
        })
      },
      departamento: {
        required: requiredIf(function () {
          return !this.isNewChk;
        })
      },
      centro: {
        required: requiredIf(function () {
          return !this.isNewChk;
        })
      },
      destino: {
        required: requiredIf(function () {
          return !this.isNewChk;
        }),
        maxLength: maxLength(200)
      },
      motivo_viaje: {
        required: requiredIf(function () {
          return !this.isNewChk;
        }),
        maxLength: maxLength(250)
      },
      fecha_salida: {
        required: requiredIf(function () {
          return !this.isNewChk;
        })
      },
      fecha_regreso: {
        required: requiredIf(function () {
          return !this.isNewChk;
        })
      },
      dias_viaje: {
        required: requiredIf(function () {
          return !this.isNewChk;
        }),
        integer,
        minValue: minValue(1),
        maxValue: maxValue(100)
      },
      importe_total: {
        required: requiredIf(function () {
          return !this.isNewChk;
        }),
        integer,
        minValue: minValue(0.01),
        maxValue: maxValue(999999.99)
      },
      // ruta_traslado: { required: requiredIf(function() { return !this.isNewChk }) },
      tipo_solicitud: {
        required: requiredIf(function () {
          return !this.isNewChk;
        })
      },
      banco: {
        required: requiredIf(function () {
          return this.isTransfer && !this.isNewChk;
        })
      },
      cuenta: {
        required: requiredIf(function () {
          return this.isTransfer && !this.isNewChk;
        })
      },
      tarjeta: {
        required: requiredIf(function () {
          return this.isTransfer && !this.isNewChk;
        })
      },
      clabe: {
        required: requiredIf(function () {
          return this.isTransfer && !this.isNewChk;
        })
      }
      /*aerolinea: { required: requiredIf(function() { return !this.isNewChk }), maxLength: maxLength(100) },
      hotel: { required: requiredIf(function() { return !this.isNewChk }), maxLength: maxLength(100) },
      costo_boleto: { required: requiredIf(function() { return !this.isNewChk }), decimal, minValue: minValue(0), maxValue: maxValue(999999.99) },
      no_noches: { required: requiredIf(function() { return !this.isNewChk }), integer, minValue: minValue(0), maxValue: maxValue(999999) },
      tarifa: { required: requiredIf(function() { return !this.isNewChk }), decimal, minValue: minValue(0), maxValue: maxValue(999999.99) },*/
      /*conceptos: {
        required: requiredIf(function() { return !this.isNewChk }),
        $each: {
          importe: { required: requiredIf(function() { return !this.isNewChk }), decimal, minValue: minValue(0), maxValue: maxValue(999999.99) }
        }
      }*/
    },
    detalle: {
      nuevo_comprobante: {
        tipo_gasto: {
          required: requiredIf(function () {
            return this.isNewChk;
          })
        },
        concepto: {
          required: requiredIf(function () {
            return this.isNewChk;
          })
        },
        detalle_no: {
          required: requiredIf(function () {
            return this.isNewChk && !this.gastoDeducible;
          })
        },
        rfc: {
          required: requiredIf(function () {
            return this.isNewChk && this.gastoDeducible;
          }),
          maxLength: maxLength(13)
        },
        beneficiario: {
          required: requiredIf(function () {
            return this.isNewChk && this.gastoDeducible;
          }),
          maxLength: maxLength(250)
        },
        folio: {
          required: requiredIf(function () {
            return this.isNewChk && this.gastoDeducible;
          }),
          maxLength: maxLength(60)
        },
        uuid: {
          required: requiredIf(function () {
            return this.isNewChk && this.gastoDeducible;
          }),
          maxLength: maxLength(36)
        },
        subtotal: {
          required: requiredIf(function () {
            return this.isNewChk;
          }),
          decimal,
          minValue: minValue(0.01),
          maxValue: maxValue(999999.99)
        },
        descuento: {
          required: requiredIf(function () {
            return this.isNewChk;
          }),
          decimal,
          minValue: minValue(0),
          maxValue: maxValue(999999.99)
        },
        iva: {
          required: requiredIf(function () {
            return this.isNewChk;
          }),
          decimal,
          minValue: minValue(0),
          maxValue: maxValue(999999.99)
        },
        total: {
          required: requiredIf(function () {
            return this.isNewChk;
          }),
          decimal,
          minValue: minValue(0.01),
          maxValue: maxValue(999999.99)
        }
      }
    }
  },
  data: () => ({
    loading: false,
    success: false,
    error: false,
    msgSuccess: "",
    msgError: "",
    dialogNewReq: false,
    dialogDetReq: false,
    dialogNewChk: false,
    dialogDetChk: false,
    questionReq: false,
    questionChk: false,
    questionDelChk: false,
    menuDateExit: false,
    menuDateReturn: false,
    search: "",
    pagination: {
      rowsPerPage: 7
    },
    headers: [
      { text: "Id", align: "center", sortable: false, value: "id_seg" },
      {
        text: "Estado de Anticipo",
        align: "center",
        sortable: false,
        value: "estado"
      },
      {
        text: "Estado de Comprobación",
        align: "center",
        sortable: false,
        value: "estado_comprobacion"
      },
      {
        text: "Fecha de Salida",
        align: "center",
        sortable: false,
        value: "fecha_salida"
      },
      {
        text: "Fecha de Regreso",
        align: "center",
        sortable: false,
        value: "fecha_regreso"
      },
      {
        text: "Importe de Anticipo",
        align: "center",
        sortable: false,
        value: "importe_anticipo"
      },
      {
        text: "Importe Comprobado",
        align: "center",
        sortable: false,
        value: "importe_comprobado"
      },
      {
        text: "Importe Restante",
        align: "center",
        sortable: false,
        value: "importe_restante"
      },
      //{ text: 'Fecha de Registro', align: 'center', sortable: false, value: 'fecha_registro' },
      {
        text: "Fecha de Actualización",
        align: "center",
        sortable: false,
        value: "fecha_actualizacion"
      }
    ],
    headersResumen: [
      {
        text: "TIPO DE GASTO",
        align: "center",
        sortable: false,
        value: "tipo_gasto"
      },
      { text: "CONCEPTO", align: "center", sortable: false, value: "concepto" },
      {
        text: "FECHA DE TIMBRADO",
        align: "center",
        sortable: false,
        value: "fecha_timbrado"
      },
      /*{ text: 'PROVEEDOR', align: 'center', sortable: false, value: 'proveedor' },*/
      {
        text: "SUB TOTAL",
        align: "center",
        sortable: false,
        value: "subtotal"
      },
      { text: "IVA", align: "center", sortable: false, value: "iva" },
      { text: "TOTAL", align: "center", sortable: false, value: "total" }
    ],
    anticipos: [],
    catalogos: {
      centros: [],
      conceptos: [],
      motivos_viaje: []
    },
    color: {
      pdf: "",
      xml: "",
      foto: ""
    },
    solicitud: {
      beneficiario: "",
      puesto: "",
      empresa: "",
      plaza: "",
      departamento: "",
      centro: "",
      destino: "",
      motivo_viaje: "",
      fecha_salida: "",
      fecha_regreso: "",
      dias_viaje: "",
      importe_total: "",
      ruta_traslado: [],
      tipo_solicitud: null,
      banco: "",
      cuenta: "",
      tarjeta: "",
      clabe: "",
      aerolinea: "",
      hotel: "",
      costo_boleto: "",
      no_noches: "",
      tarifa: "",
      conceptos: []
    },
    detalle: {
      id: "",
      beneficiario: "",
      puesto: "",
      empresa: "",
      plaza: "",
      departamento: "",
      centro: "",
      destino: "",
      importe_total: "",
      motivo_viaje: "",
      fecha_salida: "",
      fecha_regreso: "",
      dias_viaje: "",
      ruta_traslado: [],
      tipo_solicitud: null,
      banco: "",
      cuenta: "",
      tarjeta: "",
      clabe: "",
      aerolinea: "",
      hotel: "",
      costo_boleto: "",
      no_noches: "",
      tarifa: "",
      centros: [],
      conceptos: [],
      conceptos_sat: [],
      detalles_no: [],
      importe_total: "",
      comprobantes: [],
      resumen: {
        no_comprobantes: 0,
        subtotal: 0,
        iva: 0,
        neto: 0
      },
      nuevo_comprobante: {
        tipo_gasto: "deducible",
        centro: null,
        concepto: "",
        detalle_no: "",
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        rfc: "",
        beneficiario: "",
        folio: "",
        uuid: "",
        fecha_timbrado: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: ""
      },
      detalle_comprobante: {
        index: "",
        tipo_gasto: "",
        centro: null,
        concepto: "",
        detalle_no: "",
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        rfc: "",
        beneficiario: "",
        folio: "",
        uuid: "",
        fecha_timbrado: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: ""
      },
      firmas_anticipo: [],
      firmas_comprobante: []
    },
    idElementoSeleccionado: null,
    editNoFactura: false
  }),
  watch: {
    "detalle.nuevo_comprobante.tipo_gasto"(val) {
      this.$v.$reset();
      this.color = {
        pdf: "",
        xml: "",
        foto: ""
      };
      this.detalle.nuevo_comprobante.centro = null;
      this.detalle.nuevo_comprobante.concepto = "";
      this.detalle.nuevo_comprobante.detalle_no = "";
      this.detalle.nuevo_comprobante.rfc = "";
      this.detalle.nuevo_comprobante.beneficiario = "";
      this.detalle.nuevo_comprobante.folio = "";
      this.detalle.nuevo_comprobante.uuid = "";
      this.detalle.nuevo_comprobante.fecha_timbrado = "";
      this.detalle.nuevo_comprobante.subtotal = "";
      this.detalle.nuevo_comprobante.descuento = "0";
      this.detalle.nuevo_comprobante.iva = "0";
      this.detalle.nuevo_comprobante.total = "";
      this.$refs.pdf.value = "";
      this.$refs.xml.value = "";
      this.$refs.foto.value = "";
      if (val === "no_deducible") {
        for (let i = 0; i < this.detalle.conceptos.length; i++) {
          if (
            this.detalle.conceptos[i].cuenta == "12204" &&
            this.detalle.conceptos[i].subcuenta == "000000"
          ) {
            this.detalle.nuevo_comprobante.concepto = this.detalle.conceptos[
              i
            ].id;
          }
        }
      }
    }
  },
  mounted() {
    this.refresh();
  },
  computed: {
    esNoDeducible() {
      const aux = this.detalle.nuevo_comprobante.tipo_gasto === "no_deducible";
      if (aux) {
        this.detalle.nuevo_comprobante.iva = 0;
        this.detalle.nuevo_comprobante.descuento = 0;
      }
      return aux;
    },
    beneficiarioErrors() {
      const errors = [];
      if (!this.$v.solicitud.beneficiario.$dirty) return errors;
      !this.$v.solicitud.beneficiario.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    puestoErrors() {
      const errors = [];
      if (!this.$v.solicitud.puesto.$dirty) return errors;
      !this.$v.solicitud.puesto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    empresaErrors() {
      const errors = [];
      if (!this.$v.solicitud.empresa.$dirty) return errors;
      !this.$v.solicitud.empresa.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    plazaErrors() {
      const errors = [];
      if (!this.$v.solicitud.plaza.$dirty) return errors;
      !this.$v.solicitud.plaza.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    departamentoErrors() {
      const errors = [];
      if (!this.$v.solicitud.departamento.$dirty) return errors;
      !this.$v.solicitud.departamento.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    centroErrors() {
      const errors = [];
      if (!this.$v.solicitud.centro.$dirty) return errors;
      !this.$v.solicitud.centro.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    destinoErrors() {
      const errors = [];
      if (!this.$v.solicitud.destino.$dirty) return errors;
      !this.$v.solicitud.destino.maxLength &&
        errors.push("El campo excede la longitud máxima");
      !this.$v.solicitud.destino.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    motivoViajeErrors() {
      const errors = [];
      if (!this.$v.solicitud.motivo_viaje.$dirty) return errors;
      !this.$v.solicitud.motivo_viaje.maxLength &&
        errors.push("El campo excede la longitud máxima");
      !this.$v.solicitud.motivo_viaje.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    fechaSalidaErrors() {
      const errors = [];
      if (!this.$v.solicitud.fecha_salida.$dirty) return errors;
      !this.$v.solicitud.fecha_salida.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    fechaRegresoErrors() {
      const errors = [];
      if (!this.$v.solicitud.fecha_regreso.$dirty) return errors;
      !this.$v.solicitud.fecha_regreso.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    diasViajeErrors() {
      const errors = [];
      if (!this.$v.solicitud.dias_viaje.$dirty) return errors;
      !this.$v.solicitud.dias_viaje.integer &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.dias_viaje.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.dias_viaje.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.dias_viaje.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    importeTotalErrors() {
      const errors = [];
      if (!this.$v.solicitud.importe_total.$dirty) return errors;
      !this.$v.solicitud.importe_total.integer &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.importe_total.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.importe_total.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.importe_total.required &&
        errors.push("El campo es obligatorio");
      !this.checkImporteTotal &&
        errors.push("El importe máximo por día es de $2,000.00 MXN");
      return errors;
    },
    /*rutaTrasladoErrors() {
      const errors = []
      if (!this.$v.solicitud.ruta_traslado.$dirty) return errors
      !this.$v.solicitud.ruta_traslado.required && errors.push('El campo es obligatorio')
      return errors
    },*/
    diasViaje() {
      if (
        this.solicitud.fecha_salida !== "" &&
        this.solicitud.fecha_regreso != ""
      ) {
        let fecha_salida = moment(this.solicitud.fecha_salida, "YYYY-MM-DD");
        let fecha_regreso = moment(this.solicitud.fecha_regreso, "YYYY-MM-DD");
        let dias = "";
        dias = parseInt(fecha_regreso.diff(fecha_salida, "days")) + 1;
        this.solicitud.dias_viaje = dias;
      } else {
        this.solicitud.dias_viaje = "";
      }
    },
    importeTotal() {
      if (
        this.solicitud.fecha_salida !== "" &&
        this.solicitud.fecha_regreso != ""
      ) {
        let fecha_salida = moment(this.solicitud.fecha_salida, "YYYY-MM-DD");
        let fecha_regreso = moment(this.solicitud.fecha_regreso, "YYYY-MM-DD");
        let dias = "";
        dias = parseInt(fecha_regreso.diff(fecha_salida, "days")) + 1;
        this.solicitud.importe_total = 2000 * dias;
      } else {
        this.solicitud.importe_total = "";
      }
    },
    checkImporteTotal() {
      if (
        this.solicitud.fecha_salida !== "" &&
        this.solicitud.fecha_regreso != ""
      ) {
        let fecha_salida = moment(this.solicitud.fecha_salida, "YYYY-MM-DD");
        let fecha_regreso = moment(this.solicitud.fecha_regreso, "YYYY-MM-DD");
        let dias = "";
        dias = parseInt(fecha_regreso.diff(fecha_salida, "days")) + 1;
        if (this.solicitud.importe_total > 2000 * dias) {
          return false;
        }
      }
      return true;
    },
    tipoSolicitudErrors() {
      const errors = [];
      if (!this.$v.solicitud.tipo_solicitud.$dirty) return errors;
      !this.$v.solicitud.tipo_solicitud.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    bancoErrors() {
      const errors = [];
      if (!this.$v.solicitud.banco.$dirty) return errors;
      !this.$v.solicitud.banco.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    cuentaErrors() {
      const errors = [];
      if (!this.$v.solicitud.cuenta.$dirty) return errors;
      !this.$v.solicitud.cuenta.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    tarjetaErrors() {
      const errors = [];
      if (!this.$v.solicitud.cuenta.$dirty) return errors;
      !this.$v.solicitud.cuenta.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    clabeErrors() {
      const errors = [];
      if (!this.$v.solicitud.clabe.$dirty) return errors;
      !this.$v.solicitud.clabe.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    /*aerolineaErrors() {
      const errors = []
      if (!this.$v.solicitud.aerolinea.$dirty) return errors
      !this.$v.solicitud.aerolinea.maxLength && errors.push('El campo excede la longitud máxima')
      !this.$v.solicitud.aerolinea.required && errors.push('El campo es obligatorio')
      return errors
    },
    hotelErrors() {
      const errors = []
      if (!this.$v.solicitud.hotel.$dirty) return errors
      !this.$v.solicitud.hotel.maxLength && errors.push('El campo excede la longitud máxima')
      !this.$v.solicitud.hotel.required && errors.push('El campo es obligatorio')
      return errors
    },
    costoBoletoErrors() {
      const errors = []
      if (!this.$v.solicitud.costo_boleto.$dirty) return errors
      !this.$v.solicitud.costo_boleto.decimal && errors.push('El campo es inválido')
      !this.$v.solicitud.costo_boleto.minValue && errors.push('El campo no alcanza el valor mínimo')
      !this.$v.solicitud.costo_boleto.maxValue && errors.push('El campo excede el valor máximo')
      !this.$v.solicitud.costo_boleto.required && errors.push('El campo es obligatorio')
      return errors
    },
    noNochesErrors() {
      const errors = []
      if (!this.$v.solicitud.no_noches.$dirty) return errors
      !this.$v.solicitud.no_noches.integer && errors.push('El campo es inválido')
      !this.$v.solicitud.no_noches.minValue && errors.push('El campo no alcanza el valor mínimo')
      !this.$v.solicitud.no_noches.maxValue && errors.push('El campo excede el valor máximo')
      !this.$v.solicitud.no_noches.required && errors.push('El campo es obligatorio')
      return errors
    },
    tarifaErrors() {
      const errors = []
      if (!this.$v.solicitud.tarifa.$dirty) return errors
      !this.$v.solicitud.tarifa.decimal && errors.push('El campo es inválido')
      !this.$v.solicitud.tarifa.minValue && errors.push('El campo no alcanza el valor mínimo')
      !this.$v.solicitud.tarifa.maxValue && errors.push('El campo excede el valor máximo')
      !this.$v.solicitud.tarifa.required && errors.push('El campo es obligatorio')
      return errors
    },
    importeTotal() {
      let sum = 0
      for (let i = 0; i < this.solicitud.conceptos.length; i++) {
        if (!isNaN(this.solicitud.conceptos[i].importe) && this.solicitud.conceptos[i].importe !== '')
        sum += parseFloat(parseFloat(this.solicitud.conceptos[i].importe).toFixed(2))
      }
      return parseFloat(parseFloat(sum).toFixed(2))
    },*/
    isTransfer() {
      return this.solicitud.tipo_solicitud === "transferencia" ? true : false;
    },
    isNewChk() {
      return this.dialogNewChk;
    },
    gastoDeducible() {
      return (
        this.dialogNewChk &&
        this.detalle.nuevo_comprobante.tipo_gasto === "deducible"
      );
    },
    detalleGastoDeducible() {
      return (
        this.dialogDetChk &&
        this.detalle.detalle_comprobante.tipo_gasto === "deducible"
      );
    },
    iva() {
      if (this.esNoDeducible) {
        return 0;
      }
      if (
        this.dialogNewChk &&
        this.detalle.nuevo_comprobante.tipo_gasto === "no_deducible"
      ) {
        let factor = 0.16;
        let importe = parseFloat(
          parseFloat(this.detalle.nuevo_comprobante.subtotal).toFixed(2)
        );
        let descuento = parseFloat(
          parseFloat(this.detalle.nuevo_comprobante.descuento).toFixed(2)
        );
        importe = isNaN(importe) ? 0 : importe;
        descuento = isNaN(descuento) ? 0 : descuento;
        let iva = parseFloat((importe - descuento) * factor).toFixed(2);
        this.detalle.nuevo_comprobante.iva = iva;
      }
    },
    total() {
      if (
        this.dialogNewChk &&
        this.detalle.nuevo_comprobante.tipo_gasto === "no_deducible"
      ) {
        let importe = parseFloat(
          parseFloat(this.detalle.nuevo_comprobante.subtotal).toFixed(2)
        );
        let descuento = parseFloat(
          parseFloat(this.detalle.nuevo_comprobante.descuento).toFixed(2)
        );
        let iva = parseFloat(
          parseFloat(this.detalle.nuevo_comprobante.iva).toFixed(2)
        );
        importe = isNaN(importe) ? 0 : importe;
        descuento = isNaN(descuento) ? 0 : descuento;
        iva = isNaN(iva) ? 0 : iva;
        this.detalle.nuevo_comprobante.total = parseFloat(
          importe - descuento + iva
        ).toFixed(2);
      }
    },
    tipoGastoErrors() {
      const errors = [];
      if (!this.$v.detalle.nuevo_comprobante.tipo_gasto.$dirty) return errors;
      !this.$v.detalle.nuevo_comprobante.tipo_gasto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    conceptoErrors() {
      const errors = [];
      if (!this.$v.detalle.nuevo_comprobante.concepto.$dirty) return errors;
      !this.$v.detalle.nuevo_comprobante.concepto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    detalleNoErrors() {
      const errors = [];
      if (!this.$v.detalle.nuevo_comprobante.detalle_no.$dirty) return errors;
      !this.$v.detalle.nuevo_comprobante.detalle_no.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    rfcErrors() {
      const errors = [];
      if (!this.$v.detalle.nuevo_comprobante.rfc.$dirty) return errors;
      !this.$v.detalle.nuevo_comprobante.rfc.maxLength &&
        errors.push("El campo excede el valor máximo");
      !this.$v.detalle.nuevo_comprobante.rfc.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    beneficiarioErrors() {
      const errors = [];
      if (!this.$v.detalle.nuevo_comprobante.beneficiario.$dirty) return errors;
      !this.$v.detalle.nuevo_comprobante.beneficiario.maxLength &&
        errors.push("El campo excede el valor máximo");
      !this.$v.detalle.nuevo_comprobante.beneficiario.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    folioErrors() {
      const errors = [];
      if (!this.$v.detalle.nuevo_comprobante.folio.$dirty) return errors;
      !this.$v.detalle.nuevo_comprobante.folio.maxLength &&
        errors.push("El campo excede el valor máximo");
      !this.$v.detalle.nuevo_comprobante.folio.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    uuidErrors() {
      const errors = [];
      if (!this.$v.detalle.nuevo_comprobante.uuid.$dirty) return errors;
      !this.$v.detalle.nuevo_comprobante.uuid.maxLength &&
        errors.push("El campo excede el valor máximo");
      !this.$v.detalle.nuevo_comprobante.uuid.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    subtotalErrors() {
      const errors = [];
      if (!this.$v.detalle.nuevo_comprobante.subtotal.$dirty) return errors;
      !this.$v.detalle.nuevo_comprobante.subtotal.decimal &&
        errors.push("El campo es inválido");
      !this.$v.detalle.nuevo_comprobante.subtotal.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.detalle.nuevo_comprobante.subtotal.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.detalle.nuevo_comprobante.subtotal.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    descuentoErrors() {
      const errors = [];
      if (!this.$v.detalle.nuevo_comprobante.descuento.$dirty) return errors;
      !this.$v.detalle.nuevo_comprobante.descuento.decimal &&
        errors.push("El campo es inválido");
      !this.$v.detalle.nuevo_comprobante.descuento.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.detalle.nuevo_comprobante.descuento.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.detalle.nuevo_comprobante.descuento.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    ivaErrors() {
      const errors = [];
      if (!this.$v.detalle.nuevo_comprobante.iva.$dirty) return errors;
      !this.$v.detalle.nuevo_comprobante.iva.decimal &&
        errors.push("El campo es inválido");
      !this.$v.detalle.nuevo_comprobante.iva.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.detalle.nuevo_comprobante.iva.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.detalle.nuevo_comprobante.iva.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    totalErrors() {
      const errors = [];
      if (!this.$v.detalle.nuevo_comprobante.total.$dirty) return errors;
      !this.$v.detalle.nuevo_comprobante.total.decimal &&
        errors.push("El campo es inválido");
      !this.$v.detalle.nuevo_comprobante.total.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.detalle.nuevo_comprobante.total.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.detalle.nuevo_comprobante.total.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    tableResumen() {
      let resumen = [];
      let detalle = {};
      for (let i = 0; i < this.detalle.comprobantes.length; i++) {
        let tipo_gasto = this.detalle.comprobantes[i].tipo_gasto;
        let concepto = "";
        let fecha_timbrado = this.detalle.comprobantes[i].fecha_timbrado;
        let proveedor = this.detalle.comprobantes[i].beneficiario;
        let subtotal = this.detalle.comprobantes[i].subtotal;
        let iva = this.detalle.comprobantes[i].iva;
        let total = this.detalle.comprobantes[i].total;
        for (let j = 0; j < this.detalle.conceptos.length; j++) {
          if (
            this.detalle.conceptos[j].id ==
            this.detalle.comprobantes[i].concepto
          ) {
            concepto = this.detalle.conceptos[j].descripcion;
          }
        }
        if (tipo_gasto === "deducible") {
          tipo_gasto = "DEDUCIBLE";
        } else if (tipo_gasto === "no_deducible") {
          tipo_gasto = "NO DEDUCIBLE";
        }
        if (!detalle[tipo_gasto]) {
          detalle[tipo_gasto] = {};
        }
        if (!detalle[tipo_gasto][concepto]) {
          detalle[tipo_gasto][concepto] = {
            fecha_timbrado: fecha_timbrado,
            proveedor: proveedor,
            subtotal: 0,
            iva: 0,
            total: 0
          };
        }
        detalle[tipo_gasto][concepto].subtotal += subtotal;
        detalle[tipo_gasto][concepto].iva += iva;
        detalle[tipo_gasto][concepto].total += total;
      }
      let keysTipoGasto = Object.keys(detalle);
      for (let i = 0; i < keysTipoGasto.length; i++) {
        let keysConcepto = Object.keys(detalle[keysTipoGasto[i]]);
        for (let j = 0; j < keysConcepto.length; j++) {
          resumen.push({
            tipo_gasto: keysTipoGasto[i],
            concepto: keysConcepto[j],
            fecha_timbrado:
              detalle[keysTipoGasto[i]][keysConcepto[j]].fecha_timbrado,
            proveedor: detalle[keysTipoGasto[i]][keysConcepto[j]].proveedor,
            subtotal: detalle[keysTipoGasto[i]][keysConcepto[j]].subtotal,
            iva: detalle[keysTipoGasto[i]][keysConcepto[j]].iva,
            total: detalle[keysTipoGasto[i]][keysConcepto[j]].total
          });
        }
      }
      for (let i = 0; i < resumen.length; i++) {
        resumen[i].fecha_timbrado = resumen[i].fecha_timbrado.split("T")[0];
        resumen[i].subtotal =
          "$" +
          resumen[i].subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        resumen[i].iva =
          "$" + resumen[i].iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        resumen[i].total =
          "$" +
          resumen[i].total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return resumen;
    }
  },
  methods: {
    ws(method, name, data) {
      if (method === "get") {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          let params = "";
          for (let k in data) {
            params += k + "=" + data[k] + "&";
          }
          params = params !== "" ? "?" + params : "";
          return axios
            .get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      } else {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          return axios
            .post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      }
    },
    refresh() {
      this.loading = true;
      this.ws("get", "anticiposViaje")
        .then(res => {
          if (res.ok) {
            this.anticipos = res.data;
          } else {
            this.anticipos = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    importeErrors(idx) {
      const errors = [];
      if (!this.$v.solicitud.conceptos.$each[idx].importe.$dirty) return errors;
      !this.$v.solicitud.conceptos.$each[idx].importe.decimal &&
        errors.push("El campo es inválido");
      !this.$v.solicitud.conceptos.$each[idx].importe.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.solicitud.conceptos.$each[idx].importe.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.solicitud.conceptos.$each[idx].importe.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    prepareForm(data) {
      this.solicitud.beneficiario = (
        data.detalle.nombre +
        " " +
        data.detalle.apellido_paterno +
        " " +
        data.detalle.apellido_materno
      ).trim();
      this.solicitud.puesto = data.detalle.puesto;
      this.solicitud.empresa = data.detalle.empresa;
      this.solicitud.plaza = data.detalle.direccion;
      this.solicitud.departamento = data.detalle.departamento;
      this.catalogos.centros = data.catalogos.centros;
      this.catalogos.conceptos = data.catalogos.conceptos.filter(concepto => {
        return concepto.categoria == "GASTOS DE VIAJE";
      });
      this.catalogos.motivos_viaje = data.catalogos.motivos_viaje;
      this.solicitud.banco = data.detalle.nomina_banco;
      this.solicitud.cuenta = data.detalle.nomina_cuenta;
      this.solicitud.tarjeta = data.detalle.nomina_tarjeta;
      (this.solicitud.clabe = data.detalle.nomina_clabe),
        (this.solicitud.conceptos = this.catalogos.conceptos);
      this.detalle.nuevo_comprobante.conceptos = data.conceptos;
      this.dialogNewReq = true;
    },
    newRequest() {
      this.loading = true;
      this.ws("get", "detalleUsuario")
        .then(res => {
          if (res.ok) {
            this.prepareForm(res.data);
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.$v.$reset();
      this.catalogos = {
        centros: [],
        conceptos: [],
        motivos_viaje: []
      };
      this.color = {
        pdf: "",
        xml: "",
        foto: ""
      };
      this.solicitud = {
        beneficiario: "",
        puesto: "",
        empresa: "",
        plaza: "",
        departamento: "",
        centro: "",
        destino: "",
        motivo_viaje: "",
        fecha_salida: "",
        fecha_regreso: "",
        dias_viaje: "",
        importe_total: "",
        ruta_traslado: [],
        tipo_solicitud: null,
        banco: "",
        cuenta: "",
        tarjeta: "",
        clabe: "",
        aerolinea: "",
        hotel: "",
        costo_boleto: "",
        no_noches: "",
        tarifa: "",
        conceptos: []
      };
      this.detalle = {
        id: "",
        beneficiario: "",
        puesto: "",
        empresa: "",
        plaza: "",
        departamento: "",
        centro: "",
        destino: "",
        motivo_viaje: "",
        fecha_salida: "",
        fecha_regreso: "",
        dias_viaje: "",
        importe_total: "",
        ruta_traslado: [],
        tipo_solicitud: null,
        banco: "",
        cuenta: "",
        tarjeta: "",
        clabe: "",
        aerolinea: "",
        hotel: "",
        costo_boleto: "",
        no_noches: "",
        tarifa: "",
        centros: [],
        conceptos: [],
        conceptos_sat: [],
        detalles_no: [],
        importe_total: "",
        comprobantes: [],
        resumen: {
          no_comprobantes: 0,
          subtotal: 0,
          iva: 0,
          neto: 0
        },
        nuevo_comprobante: {
          tipo_gasto: "deducible",
          centro: null,
          concepto: "",
          detalle_no: "",
          pdf: { id: "", nombre: "", data: null },
          xml: { id: "", nombre: "", data: null },
          foto: { id: "", nombre: "", data: null },
          rfc: "",
          beneficiario: "",
          folio: "",
          uuid: "",
          fecha_timbrado: "",
          subtotal: "",
          descuento: "",
          iva: "",
          total: ""
        },
        detalle_comprobante: {
          index: "",
          tipo_gasto: "",
          centro: null,
          concepto: "",
          detalle_no: "",
          pdf: { nombre: "", data: null },
          xml: { nombre: "", data: null },
          foto: { nombre: "", data: null },
          rfc: "",
          beneficiario: "",
          folio: "",
          uuid: "",
          fecha_timbrado: "",
          subtotal: "",
          descuento: "",
          iva: "",
          total: ""
        },
        firmas_anticipo: [],
        firmas_comprobante: []
      };
      this.$v.$reset();
      this.dialogNewReq = false;
      this.dialogDetReq = false;
    },
    save() {
      this.questionReq = false;
      this.$v.$touch();
      if (!this.$v.$invalid && this.checkImporteTotal) {
        this.loading = true;
        let data = {
          centro: this.solicitud.centro,
          destino: this.solicitud.destino,
          motivo_viaje: this.solicitud.motivo_viaje,
          fecha_salida: this.solicitud.fecha_salida,
          fecha_regreso: this.solicitud.fecha_regreso,
          importe_total: this.solicitud.importe_total,
          //ruta_traslado: this.solicitud.ruta_traslado,
          tipo_solicitud: this.solicitud.tipo_solicitud
          /*aerolinea: this.solicitud.aerolinea,
          hotel: this.solicitud.hotel,
          costo_boleto: this.solicitud.costo_boleto,
          no_noches: this.solicitud.no_noches,
          tarifa: this.solicitud.tarifa,
          conceptos: this.solicitud.conceptos*/
        };
        this.ws("post", "nuevaSolicitudAnticipoViaje", data)
          .then(res => {
            if (res.ok) {
              this.close();
              this.refresh();
              this.success = true;
              this.msgSuccess = res.message;
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    prepareDetailForm(id, data) {
      this.detalle.id = id;
      this.detalle.beneficiario = data.detalle_usuario.beneficiario;
      this.detalle.puesto = data.detalle_usuario.puesto;
      this.detalle.empresa = data.detalle_usuario.empresa;
      this.detalle.plaza = data.detalle_usuario.plaza;
      this.detalle.departamento = data.detalle_usuario.departamento;
      this.detalle.estado = data.solicitud.estado;
      this.detalle.centro = data.solicitud.centro;
      this.detalle.destino = data.solicitud.destino;
      this.detalle.motivo_viaje = data.solicitud.motivo_viaje;
      this.detalle.fecha_salida = data.solicitud.fecha_salida;
      this.detalle.fecha_regreso = data.solicitud.fecha_regreso;
      let fecha_salida = moment(this.detalle.fecha_salida, "YYYY-MM-DD");
      let fecha_regreso = moment(this.detalle.fecha_regreso, "YYYY-MM-DD");
      this.detalle.dias_viaje =
        parseInt(fecha_regreso.diff(fecha_salida, "days")) + 1;
      this.detalle.importe_total = data.solicitud.importe_total
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      //this.detalle.ruta_traslado = data.solicitud.ruta_traslado
      this.detalle.tipo_solicitud = data.solicitud.tipo_solicitud;
      this.detalle.banco = data.detalle_usuario.banco;
      this.detalle.cuenta = data.detalle_usuario.cuenta;
      this.detalle.tarjeta = data.detalle_usuario.tarjeta;
      this.detalle.clabe = data.detalle_usuario.clabe;
      /*this.detalle.aerolinea = data.solicitud.aerolinea
      this.detalle.hotel = data.solicitud.hotel
      this.detalle.costo_boleto = data.solicitud.costo_boleto
      this.detalle.no_noches = data.solicitud.no_noches
      this.detalle.tarifa = data.solicitud.tarifa*/
      this.detalle.centros = data.centros;
      this.detalle.conceptos = data.conceptos;
      this.detalle.conceptos_sat = data.conceptos_sat;
      this.detalle.detalles_no = data.detalles_no;
      /*let sum = 0
      for (let i = 0; i < this.detalle.conceptos.length; i++) {
        sum += parseFloat(parseFloat(this.detalle.conceptos[i].importe).toFixed(2))
      }
      this.detalle.importe_total = sum*/
      this.detalle.comprobantes = data.comprobantes;
      let subtotal = 0;
      let iva = 0;
      let total = 0;
      for (let i = 0; i < this.detalle.comprobantes.length; i++) {
        subtotal += parseFloat(
          this.detalle.comprobantes[i].subtotal.toFixed(2)
        );
        iva += parseFloat(this.detalle.comprobantes[i].iva.toFixed(2));
        total += parseFloat(this.detalle.comprobantes[i].total.toFixed(2));
      }
      this.detalle.resumen.no_comprobantes = this.detalle.comprobantes.length;
      this.detalle.resumen.subtotal = subtotal
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalle.resumen.iva = iva
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalle.resumen.neto = total
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalle.firmas_anticipo = data.firmas_anticipo;
      this.detalle.firmas_comprobante = data.firmas_comprobante;
      this.dialogDetReq = true;
    },
    showDetailReq(id) {
      this.loading = true;
      this.idElementoSeleccionado = id;
      this.ws("get", "detalleSolicitudAnticipoViaje", { id })
        .then(res => {
          if (res.ok) {
            this.prepareDetailForm(id, res.data);
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    readFile(doc) {
      return new Promise(() => {
        let fr = new FileReader();
        let file = this.$refs[doc].files;
        let name = file[0].name;
        let size = file[0].size;
        if (size <= 10000000) {
          fr.onload = () => {
            this.detalle.nuevo_comprobante[doc].nombre = name;
            this.detalle.nuevo_comprobante[doc].data = fr.result;
            this.color[doc] = "success";
            if (doc === "xml") {
              this.detalle.nuevo_comprobante.rfc = "";
              this.detalle.nuevo_comprobante.beneficiario = "";
              this.detalle.nuevo_comprobante.folio = "";
              this.detalle.nuevo_comprobante.uuid = "";
              this.detalle.nuevo_comprobante.fecha_timbrado = "";
              this.detalle.nuevo_comprobante.subtotal = "";
              this.detalle.nuevo_comprobante.descuento = "";
              this.detalle.nuevo_comprobante.iva = "";
              this.detalle.nuevo_comprobante.total = "";
              let xml = decodeURIComponent(
                escape(
                  atob(this.detalle.nuevo_comprobante[doc].data.split(",")[1])
                )
              );
              xml = xml.replace(/(\r\n|\n|\r)/g, "");
              let regExp = /cfdi\:Concepto.+ClaveProdServ=\"(\d+)\"/;
              let matches = regExp.exec(xml);
              let cve = "";
              let cuenta = "";
              let subcuenta = "";
              if (matches != null) {
                cve = matches[1];
                for (let i = 0; i < this.detalle.conceptos_sat.length; i++) {
                  if (this.detalle.conceptos_sat[i].clave == cve) {
                    cuenta = this.detalle.conceptos_sat[i].cuenta;
                    subcuenta = this.detalle.conceptos_sat[i].subcuenta;
                    for (let j = 0; j < this.detalle.conceptos.length; j++) {
                      if (
                        this.detalle.conceptos[j].cuenta == cuenta &&
                        this.detalle.conceptos[j].subcuenta == subcuenta
                      ) {
                        this.detalle.nuevo_comprobante.concepto = this.detalle.conceptos[
                          j
                        ].id;
                      }
                    }
                  }
                }
                if (cuenta == "" || subcuenta == "") {
                  for (let i = 0; i < this.detalle.conceptos.length; i++) {
                    if (
                      this.detalle.conceptos[i].cuenta == "12204" &&
                      this.detalle.conceptos[i].subcuenta == "000000"
                    ) {
                      this.detalle.nuevo_comprobante.concepto = this.detalle.conceptos[
                        i
                      ].id;
                    }
                  }
                }
              } else {
                for (let i = 0; i < this.detalle.conceptos.length; i++) {
                  if (
                    this.detalle.conceptos[i].cuenta == "12204" &&
                    this.detalle.conceptos[i].subcuenta == "000000"
                  ) {
                    this.detalle.nuevo_comprobante.concepto = this.detalle.conceptos[
                      i
                    ].id;
                  }
                }
              }
              regExp = /cfdi\:Emisor.+?Rfc=\"([A-Z0-9]+)\"/;
              matches = regExp.exec(xml);
              this.detalle.nuevo_comprobante.rfc =
                matches != null ? matches[1] : "";
              regExp = /cfdi\:Emisor.+?Nombre ?=\"([a-zA-Z0-9äÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙ,. ]+)\"/;
              matches = regExp.exec(xml);
              this.detalle.nuevo_comprobante.beneficiario =
                matches != null ? matches[1] : "";
              regExp = /cfdi\:Comprobante.+?Serie=\"([a-zA-Z0-9/ -]+)\"/;
              matches = regExp.exec(xml);
              let serie = matches != null ? matches[1] : "";
              regExp = /cfdi\:Comprobante.+?Folio=\"([a-zA-Z0-9/ -]+)\"/;
              matches = regExp.exec(xml);
              this.detalle.nuevo_comprobante.folio =
                matches != null ? matches[1] : "";
              if (this.detalle.nuevo_comprobante.folio == "") {
                regExp = /tfd\:TimbreFiscalDigital.+?UUID\s*=\s*\"([a-zA-Z0-9-]+)\"/;
                matches = regExp.exec(xml);
                this.detalle.nuevo_comprobante.folio =
                  matches != null ? matches[1] : "";
              }
              this.detalle.nuevo_comprobante.folio =
                serie + this.detalle.nuevo_comprobante.folio;
              regExp = /tfd\:TimbreFiscalDigital.+?UUID\s*=\s*\"([a-zA-Z0-9-]+)\"/;
              matches = regExp.exec(xml);
              this.detalle.nuevo_comprobante.uuid =
                matches != null ? matches[1] : "";
              regExp = /FechaTimbrado\s*=\s*\"([^\"]+)\"/;
              matches = regExp.exec(xml);
              this.detalle.nuevo_comprobante.fecha_timbrado =
                matches != null ? matches[1] : "";
              regExp = /cfdi\:Comprobante.+?SubTotal=\"\s*(\d+\.?\d*)\s*\"/;
              matches = regExp.exec(xml);
              this.detalle.nuevo_comprobante.subtotal =
                matches != null ? matches[1] : "";
              regExp = /cfdi\:Comprobante.+?Descuento=\"\s*(\d+\.?\d*)\s*\"/;
              matches = regExp.exec(xml);
              this.detalle.nuevo_comprobante.descuento =
                matches != null ? matches[1] : "0.00";
              regExp = /cfdi\:Impuestos.+?TotalImpuestosTrasladados=\"(\d+\.?\d*)\"/;
              matches = regExp.exec(xml);
              this.detalle.nuevo_comprobante.iva =
                matches != null ? matches[1] : "0.00";
              regExp = /cfdi\:Comprobante.+? Total=\"(\d+\.?\d*)\"/;
              matches = regExp.exec(xml);
              this.detalle.nuevo_comprobante.total =
                matches != null ? matches[1] : "";
              this.editNoFactura =
                this.detalle.nuevo_comprobante.folio === "" ? true : false;
            }
          };
          fr.onerror = () => {
            this.color[doc] = "";
            this.error = true;
            this.msgError = "El archivo no fue leído correctamente";
          };
          fr.readAsDataURL(file[0]);
        } else {
          this.detalle.nuevo_comprobante[doc].id = "";
          this.error = true;
          this.msgError = "El archivo ha excedido el límite permitido (10 MB)";
        }
      });
    },
    closeNewChk() {
      this.$v.$reset();
      this.color = {
        pdf: "",
        xml: "",
        foto: ""
      };
      this.detalle.nuevo_comprobante = {
        tipo_gasto: "deducible",
        centro: null,
        concepto: "",
        detalle_no: "",
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        rfc: "",
        beneficiario: "",
        folio: "",
        uuid: "",
        fecha_timbrado: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: ""
      };
      this.detalle.detalle_comprobante = {
        index: "",
        tipo_gasto: "",
        centro: null,
        concepto: "",
        detalle_no: "",
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        rfc: "",
        beneficiario: "",
        folio: "",
        uuid: "",
        fecha_timbrado: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: ""
      };
      this.$refs.pdf.value = "";
      this.$refs.xml.value = "";
      this.$refs.foto.value = "";
      this.editNoFactura = false;
      this.dialogNewChk = false;
    },
    saveNewChk() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (
          this.detalle.nuevo_comprobante.tipo_gasto === "deducible" &&
          (this.detalle.nuevo_comprobante.pdf.data === null ||
            this.detalle.nuevo_comprobante.xml.data === null)
        ) {
          this.error = true;
          this.msgError = "Debe adjuntar los archivos PDF y XML";
        } else if (
          this.detalle.nuevo_comprobante.tipo_gasto === "no_deducible" &&
          this.detalle.nuevo_comprobante.foto.data === null
        ) {
          this.error = true;
          this.msgError = "Debe adjuntar la foto";
        } else {
          if (this.detalle.comprobantes.length < 50) {
            if (this.detalle.nuevo_comprobante.tipo_gasto === "deducible") {
              let fecha_actual = moment(moment().format("YYYY-MM-DD"));
              let fecha_factura = moment(
                this.detalle.nuevo_comprobante.fecha_timbrado.split("T")[0]
              );
              if (!fecha_factura.isValid()) {
                this.error = true;
                this.msgError = "La fecha de timbrado es incorrecta";
                return false;
              } else if (fecha_actual.diff(fecha_factura, "days") > 30) {
                this.error = true;
                this.msgError =
                  "La fecha de timbrado ha superado la antiguedad máxima (30 días)";
                return false;
              }
            }
            /*else if (!this.detalle.nuevo_comprobante.centro) {
              this.error = true
              this.msgError = 'Debe seleccionar un centro de costos'
              return false
            }*/
            this.loading = true;
            let detalle_no =
              this.detalle.nuevo_comprobante.tipo_gasto === "no_deducible"
                ? this.detalle.nuevo_comprobante.detalle_no
                : null;
            let subtotal = parseFloat(
              parseFloat(this.detalle.nuevo_comprobante.subtotal).toFixed(2)
            );
            let iva = parseFloat(
              parseFloat(this.detalle.nuevo_comprobante.iva).toFixed(2)
            );
            let total = parseFloat(
              parseFloat(this.detalle.nuevo_comprobante.total).toFixed(2)
            );
            for (let i = 0; i < this.detalle.comprobantes.length; i++) {
              subtotal += parseFloat(
                parseFloat(this.detalle.comprobantes[i].subtotal).toFixed(2)
              );
              iva += parseFloat(
                parseFloat(this.detalle.comprobantes[i].iva).toFixed(2)
              );
              total += parseFloat(
                parseFloat(this.detalle.comprobantes[i].total).toFixed(2)
              );
            }
            let comprobante = {
              tipo_gasto: this.detalle.nuevo_comprobante.tipo_gasto,
              centro: this.detalle.nuevo_comprobante.centro,
              concepto: this.detalle.nuevo_comprobante.concepto,
              detalle_no: detalle_no,
              pdf: {
                nombre: this.detalle.nuevo_comprobante.pdf.nombre,
                data: this.detalle.nuevo_comprobante.pdf.data
              },
              xml: {
                nombre: this.detalle.nuevo_comprobante.xml.nombre,
                data: this.detalle.nuevo_comprobante.xml.data
              },
              foto: {
                nombre: this.detalle.nuevo_comprobante.foto.nombre,
                data: this.detalle.nuevo_comprobante.foto.data
              },
              rfc: this.detalle.nuevo_comprobante.rfc,
              beneficiario: this.detalle.nuevo_comprobante.beneficiario,
              folio: this.detalle.nuevo_comprobante.folio,
              uuid: this.detalle.nuevo_comprobante.uuid,
              fecha_timbrado: this.detalle.nuevo_comprobante.fecha_timbrado,
              subtotal: parseFloat(
                parseFloat(this.detalle.nuevo_comprobante.subtotal).toFixed(2)
              ),
              descuento: parseFloat(
                parseFloat(this.detalle.nuevo_comprobante.descuento).toFixed(2)
              ),
              iva: parseFloat(
                parseFloat(this.detalle.nuevo_comprobante.iva).toFixed(2)
              ),
              total: parseFloat(
                parseFloat(this.detalle.nuevo_comprobante.total).toFixed(2)
              )
            };
            let data = {
              id: this.detalle.id,
              comprobante: comprobante
            };
            this.ws("post", "nuevoComprobanteAnticipoViaje", data)
              .then(res => {
                if (res.ok) {
                  comprobante.id = res.data.id;
                  this.detalle.comprobantes.push(comprobante);
                  this.detalle.resumen.no_comprobantes = this.detalle.comprobantes.length;
                  this.detalle.resumen.subtotal = subtotal
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  this.detalle.resumen.iva = iva
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  this.detalle.resumen.neto = total
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  this.closeNewChk();
                  this.success = true;
                  this.msgSuccess = res.message;
                } else {
                  this.error = true;
                  this.msgError = res.message;
                }
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            this.error = true;
            this.msgError =
              "Ha llegado al límite de comprobantes permitidos (50)";
          }
        }
      }
    },
    removeElement() {
      this.questionDelChk = false;
      this.loading = true;
      let data = {
        id: this.detalle.id,
        id_com: this.detalle.detalle_comprobante.id
      };
      this.ws("post", "eliminarComprobanteAnticipoViaje", data)
        .then(res => {
          if (res.ok) {
            this.detalle.comprobantes.splice(
              this.detalle.detalle_comprobante.index,
              1
            );
            let subtotal = 0;
            let iva = 0;
            let total = 0;
            for (let i = 0; i < this.detalle.comprobantes.length; i++) {
              subtotal += parseFloat(
                parseFloat(this.detalle.comprobantes[i].subtotal).toFixed(2)
              );
              iva += parseFloat(
                parseFloat(this.detalle.comprobantes[i].iva).toFixed(2)
              );
              total += parseFloat(
                parseFloat(this.detalle.comprobantes[i].total).toFixed(2)
              );
            }
            this.detalle.resumen.no_comprobantes = this.detalle.comprobantes.length;
            this.detalle.resumen.subtotal = subtotal
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.detalle.resumen.iva = iva
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.detalle.resumen.neto = total
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.dialogDetChk = false;
            this.success = true;
            this.msgSuccess = res.message;
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeDetailChk() {
      this.$v.$reset();
      this.color = {
        pdf: "",
        xml: "",
        foto: ""
      };
      this.detalle.nuevo_comprobante = {
        tipo_gasto: "deducible",
        centro: null,
        concepto: "",
        detalle_no: "",
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        rfc: "",
        beneficiario: "",
        folio: "",
        uuid: "",
        fecha_timbrado: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: ""
      };
      this.detalle.detalle_comprobante = {
        index: "",
        tipo_gasto: "",
        centro: null,
        concepto: "",
        detalle_no: "",
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        rfc: "",
        beneficiario: "",
        folio: "",
        uuid: "",
        fecha_timbrado: "",
        subtotal: "",
        descuento: "",
        iva: "",
        total: ""
      };
      this.dialogDetChk = false;
    },
    downloadDocument(format) {
      this.loading = true;
      setTimeout(() => {
        let data = {
          id: this.detalle.id,
          id_com: this.detalle.detalle_comprobante.id,
          tipo: format
        };
        this.ws("get", "descargarDocumentoAnticipoViaje", data)
          .then(res => {
            if (res.ok) {
              let doc = res.data.documento;
              let nombre = doc.nombre;
              let data = doc.data;
              if (data !== null && data !== "") {
                let mimetype = data.split(";")[0].split(":")[1];
                download(data, nombre, mimetype);
              } else {
                this.error = true;
                this.msgError = "El documento no se encuentra disponible";
              }
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }, 500);
    },
    showDetailChk(idx) {
      this.detalle.detalle_comprobante.index = idx;
      this.detalle.detalle_comprobante.id = this.detalle.comprobantes[idx].id;
      this.detalle.detalle_comprobante.tipo_gasto = this.detalle.comprobantes[
        idx
      ].tipo_gasto;
      this.detalle.detalle_comprobante.centro = this.detalle.comprobantes[
        idx
      ].centro;
      this.detalle.detalle_comprobante.concepto = this.detalle.comprobantes[
        idx
      ].concepto;
      this.detalle.detalle_comprobante.detalle_no = this.detalle.comprobantes[
        idx
      ].detalle_no;
      this.detalle.detalle_comprobante.rfc = this.detalle.comprobantes[idx].rfc;
      /*this.detalle.detalle_comprobante.pdf.nombre = this.detalle.comprobantes[idx].pdf.nombre
      this.detalle.detalle_comprobante.pdf.data = this.detalle.comprobantes[idx].pdf.data
      this.detalle.detalle_comprobante.xml.nombre = this.detalle.comprobantes[idx].xml.nombre
      this.detalle.detalle_comprobante.xml.data = this.detalle.comprobantes[idx].xml.data
      this.detalle.detalle_comprobante.foto.nombre = this.detalle.comprobantes[idx].foto.nombre
      this.detalle.detalle_comprobante.foto.data = this.detalle.comprobantes[idx].foto.data*/
      this.detalle.detalle_comprobante.beneficiario = this.detalle.comprobantes[
        idx
      ].beneficiario;
      this.detalle.detalle_comprobante.folio = this.detalle.comprobantes[
        idx
      ].folio;
      this.detalle.detalle_comprobante.uuid = this.detalle.comprobantes[
        idx
      ].uuid;
      this.detalle.detalle_comprobante.fecha_timbrado = this.detalle.comprobantes[
        idx
      ].fecha_timbrado;
      this.detalle.detalle_comprobante.subtotal = this.detalle.comprobantes[
        idx
      ].subtotal;
      this.detalle.detalle_comprobante.descuento = this.detalle.comprobantes[
        idx
      ].descuento;
      this.detalle.detalle_comprobante.iva = this.detalle.comprobantes[idx].iva;
      this.detalle.detalle_comprobante.total = this.detalle.comprobantes[
        idx
      ].total;
      this.detalle.detalle_comprobante.subtotal = this.detalle.detalle_comprobante.subtotal
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalle.detalle_comprobante.descuento = this.detalle.detalle_comprobante.descuento
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalle.detalle_comprobante.iva = this.detalle.detalle_comprobante.iva
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalle.detalle_comprobante.total = this.detalle.detalle_comprobante.total
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.dialogDetChk = true;
    },
    check() {
      this.questionChk = false;
      let sum = 0;
      for (let i = 0; i < this.detalle.comprobantes.length; i++) {
        sum += parseFloat(this.detalle.comprobantes[i].total.toFixed(2));
      }
      sum = parseFloat(sum.toFixed(2));
      if (sum < parseFloat(this.detalle.importe_total.replace(/,/g, ""))) {
        this.error = true;
        this.msgError = "El monto comprobado es menor al monto solicitado";
      } else {
        this.loading = true;
        let data = {
          id: this.detalle.id
        };
        this.ws("post", "nuevaComprobacionAnticipoViaje", data)
          .then(res => {
            if (res.ok) {
              this.close();
              this.refresh();
              this.success = true;
              this.msgSuccess = res.message;
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    reimburse() {
      this.loading = true;
      let data = {
        id: this.detalle.id
      };
      this.ws("post", "reembolsarAnticipoViaje", data)
        .then(res => {
          if (res.ok) {
            this.close();
            this.refresh();
            this.success = true;
            this.msgSuccess = res.message;
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    print() {
      this.loading = true;
      // Abrir ventana inmediatamente para evitar bloqueo de popup
      const pdfWindow = window.open("", "_blank");
      // Mostrar página de carga mientras se genera el PDF
      if (pdfWindow) {
        pdfWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>Generando PDF...</title>
            <style>
              body { font-family: Arial, sans-serif; display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; background: #f5f5f5; }
              .loader-container { text-align: center; }
              .spinner { border: 4px solid #e0e0e0; border-top: 4px solid #1976d2; border-radius: 50%; width: 50px; height: 50px; animation: spin 1s linear infinite; margin: 0 auto 20px; }
              @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
              h2 { color: #333; margin-bottom: 10px; }
              p { color: #666; }
            </style>
          </head>
          <body>
            <div class="loader-container">
              <div class="spinner"></div>
              <h2>Generando PDF</h2>
              <p>Por favor espere, esto puede tomar unos segundos...</p>
            </div>
          </body>
          </html>
        `);
        pdfWindow.document.close();
      }
      let data = {
        idElementoSeleccionado: this.idElementoSeleccionado
      };
      this.ws("get", "impresionDetalleGastosViaje", data)
        .then(res => {
          if (res.ok) {
            this.close();
            this.refresh();
            this.success = true;
            this.msgSuccess = res.message;
            // Redirigir la ventana al PDF
            if (pdfWindow) {
              pdfWindow.location.href = res.data;
            } else {
              window.open(res.data, "_blank");
            }
          } else {
            // Cerrar ventana si hubo error
            if (pdfWindow) {
              pdfWindow.close();
            }
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
